import axios from './axios';

export default {
  updateUserNotes: async (id, body) => {
    const { data } = await axios.put(
      `/profiles/manage-profiles/${id}/update-notes`,
      body
    );
    return data;
  },

  getManageProfile: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/profiles/manage-profiles/browse`,
      params
    );
    return data;
  },

  updateProfileSubscription: async (id, subscription) => {
    const { data } = await axios.put(
      `/profiles/manage-profiles/${id}/change-subscription?subscription=${subscription}`
    );
    return data;
  },

  get: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/projects/manage-projects/browse`,
      params
    );
    return data;
  },

  updateFeatured: async body => {
    const { data } = await axios.put(
      `/projects/manage-projects/update-featured`,
      body
    );
    return data;
  },

  createProjectCategory: async body => {
    const { data } = await axios.post(`/labels/manage-labels/create`, body);
    return data;
  },

  updateProjectCategoryStatus: async (id, active) => {
    const { data } = await axios.put(
      `/labels/manage-labels/${id}/update-status?active=${active}`
    );
    return data;
  },

  updateCategory: async (id, body) => {
    const { data } = await axios.put(
      `/labels/manage-labels/${id}/update`,
      body
    );
    return data;
  },

  deleteCategory: async id => {
    const { data } = await axios.delete(`/labels/manage-labels/${id}/delete`);
    return data;
  },

  updateSubscription: async (id, body) => {
    const { data } = await axios.put(
      `/subscriptions/manage-subscriptions/${id}/update`,
      body
    );
    return data;
  },

  getParentProjects: async query => {
    const params = { params: query };
    const { data } = await axios.get(
      `/parent-projects/manage-parent-projects/browse`,
      params
    );
    return data;
  },

  getParentProjectById: async (id, body) => {
    const { data } = await axios.get(
      `/parent-projects/manage-parent-projects/${id}`,
      body
    );
    return data;
  },

  createParentProject: async body => {
    const { data } = await axios.post(
      `/parent-projects/manage-parent-projects/create`,
      body
    );
    return data;
  },

  updateParentProject: async (id, body) => {
    const { data } = await axios.put(
      `/parent-projects/manage-parent-projects/${id}/update`,
      body
    );
    return data;
  },

  deleteParentProject: async id => {
    const { data } = await axios.delete(
      `/parent-projects/manage-parent-projects/${id}/delete`
    );
    return data;
  },

  manageParentProject: async (id, body) => {
    const { data } = await axios.post(
      `/parent-projects/manage-parent-projects/${id}/update-sub-projects`,
      body
    );
    return data;
  },

  manageFeatureSubProjects: async (id, body) => {
    const { data } = await axios.put(
      `/parent-projects/manage-parent-projects/${id}/update-featured`,
      body
    );
    return data;
  }
};
